import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
const useStyles = makeStyles(theme => ({
    textOption: {
        margin: theme.spacing(1),
        minWidth: 250,
      },
  }));

  export default function SelectComponent(props){
    const items = props.items
    if(items!=null){
      console.log(items.servicetype)
    }
    const name = props.name
    const label = props.label
    const labelFk = props.labelFk
    const value = props.value

    const classes = useStyles();
    const [state, setState]=React.useState({
      value: '',
      name: 'hai',
    });
    if(props.defaultValue!=null){
      setState({
        ...state,
        [name]: props.defaultValue,
      });
    }
      const inputLabel = React.useRef(null);
      const [ labelWidth, setLabelWidth] = React.useState(0);
      React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
      }, []);
    
      const handleChange = name => event => {
        setState({
          ...state,
          [name]: event.target.value,
        });
      };

    function createItemOption(label, value){
        return(
            <option key={label+value} value={value}>{label}</option>
        )
    }

    return(
        <FormControl variant="outlined" className={classes.textOption}>
            <InputLabel ref={inputLabel} htmlFor="outlined-value-native-simple">
            {label}
            </InputLabel>
            <Select
            native
            value={state.value}
            onChange={handleChange('value')}
            name = {name}
            id = {name}
            >
            <option value="" />
            {
                items.servicetype.service_type.map((element)=>
                createItemOption(element.description, element.id)
                )
            }
            </Select>
      </FormControl>
    )
  }